import { HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';

import { AndroidFullScreen } from '@ionic-native/android-full-screen/ngx';
import { AudioManagement } from '@ionic-native/audio-management/ngx';
import { BackgroundMode } from '@ionic-native/background-mode/ngx';
import { BatteryStatus } from '@ionic-native/battery-status/ngx';
import { BluetoothSerial } from '@ionic-native/bluetooth-serial/ngx';
import { Device } from '@ionic-native/device/ngx';
import { GoogleAnalytics } from '@ionic-native/google-analytics/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { Insomnia } from '@ionic-native/insomnia/ngx';
import { NativeAudio } from '@ionic-native/native-audio/ngx';
import { Network } from '@ionic-native/network/ngx';
import { ScreenOrientation } from '@ionic-native/screen-orientation/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage';

import { ApiModule } from './api/api.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ComponentsModule } from './components/components.module';

import * as moment from 'moment-timezone';

import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions/ngx';
import { GlobalErrorHandlerService } from './api/error-handler.service';
import { fancyAnimation } from './components/hub-animation';

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ApiModule,
    AppRoutingModule,
    IonicStorageModule.forRoot({
      name: '__hub',
      driverOrder: ['indexeddb', 'websql'],
    }),
    IonicModule.forRoot({
      mode: 'md',
      navAnimation: fancyAnimation,
    }),
    ComponentsModule,
  ],
  providers: [
    StatusBar,
    InAppBrowser,
    GoogleAnalytics,
    BluetoothSerial,
    AndroidFullScreen,
    Insomnia,
    AudioManagement,
    NativeAudio,
    BackgroundMode,
    Device,
    Network,
    BatteryStatus,
    ScreenOrientation,
    AndroidPermissions,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {
    moment.updateLocale('en', {
      relativeTime: {
        ss: '%d seconds',
        m: '%d min',
        mm: '%d min',
        h: '%d hr',
        hh: '%d hrs',
        d: '%d day',
        dd: '%d days',
      },
    });
  }
}
